import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { selectStyles } from './styles/select.style'
import HigherOrderField from './higher-order-field.component'

export class BaseSelectInput extends PureComponent {
	constructor(props) {
		super(props)
		const { elementRef } = this.props
		this.elementRef = elementRef || React.createRef()
		this.state = { value: undefined }
	}

	handleChange = (value, action) => {
		this.setState({ value: value == undefined ? null : value }, () => {
			const { id, onChange, onValueChange } = this.props
			const newValue = !!value ? value.value : ''
			onChange(id, newValue)
			onValueChange && onValueChange(newValue, action)
		})
	}

	handleBlur = () => {
		const { id, onBlur } = this.props
		onBlur(id, true)
	}

	getOption = (opt) => {
		const { options, placeholder } = this.props
		return (
			options.find((o) => o.value == opt) || {
				value: '',
				label: placeholder || 'Selecione ...',
			}
		)
	}

	componentDidMount() {
		const { value: formikValue } = this.props
		this.handleChange(this.getOption(formikValue))
	}

	componentWillReceiveProps(nextProps) {
		const { value: currentOption } = this.state
		const { value: formikValue } = nextProps
		const nextOption = this.getOption(formikValue)

		const notInitialized = currentOption == undefined
		if (notInitialized) return

		const willBeTheSameValue =
			nextOption == currentOption ||
			(!!nextOption &&
				!!currentOption &&
				nextOption.value == currentOption.value)

		if (willBeTheSameValue) return

		const isDifferentValue =
			(formikValue || '') != (!!currentOption ? currentOption.value : '')

		if (isDifferentValue) {
			this.handleChange(nextOption)
		}
	}

	render() {
		const {
			id,
			options,
			disabled,
			isClearable,
			position,
			attribute,
			placeholder,
			defaultValue,
			noOptionsMessage,
		} = this.props
		const { value } = this.state
		return (
			<HigherOrderField innerRef={this.elementRef} {...this.props}>
				<Select
					inputId={id}
					name={`${id} ${attribute + '-' + position}`}
					options={options}
					isClearable={isClearable === true ? true : false}
					value={value || ''}
					isSearchable={true}
					className={'select'}
					ref={this.elementRef}
					styles={selectStyles}
					style={{ zIndex: 10 }}
					isDisabled={disabled}
					onBlur={this.handleBlur}
					defaultValue={defaultValue}
					onChange={(value, { action }) =>
						this.handleChange(value, action)
					}
					backspaceRemovesValue={false}
					menuPortalTarget={document.body}
					placeholder={placeholder || 'Selecione ...'}
					noOptionsMessage={() => (
						<div style={{ fontSize: '16px', cursor: 'default' }}>
							{noOptionsMessage || 'Nenhuma opção para pesquisa'}
						</div>
					)}
				/>
			</HigherOrderField>
		)
	}
}

BaseSelectInput.propTypes = {
	id: PropTypes.string.isRequired,
}

export default BaseSelectInput
